// extracted by css-extract-rspack-plugin
export default {"Radio":"ReviewTypeSelector-module__Radio__tTzxP","RadioGroup":"ReviewTypeSelector-module__RadioGroup__gM5cZ","RadioText":"ReviewTypeSelector-module__RadioText__X_els"};